module.exports = __webpack_public_path__ + "assets/img/zwn.80212325.png";